module.exports = __webpack_public_path__ + "img/670x290-BG-1.833d0c67.png";